import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import Moment from 'react-moment'
import sortBy from 'array-sort-by'
import styled from 'styled-components'
import { consumptionMapActions } from '../../actions'
import { pxToRem, color } from '../../utils'
import { Grid, Content } from '../../components/Layout'
import Sidebar from '../../components/Sidebar'
import Header from '../../components/Header'
import DataTable from '../../components/Table/Table'
import { Select, Button } from '../../components/Form'
import Box from '../../components/Box'
import Modal from '../../components/Modal'
import statusDanger from '../../assets/icons/status-danger.svg'
import statusSuccess from '../../assets/icons/status-success.svg'
import statusWarning from '../../assets/icons/status-warning.svg'
import ResponsiblesContent from '../../components/ResponsiblesContent'
import ContentHeader from '../../components/ContentHeader'
import dateToBrFormat from '../../utils/dateToBrFormat'

const SeeLink = styled.a`
  color: ${color.secondary};
  text-transform: uppercase;
  text-decoration: underline;
  font-weight: bold;
  margin: auto;
  text-align: center;
  font-size: ${pxToRem(12)};
  margin-top: ${pxToRem(5)};
  display: block;
  cursor: pointer;
`

const WrapperSeeButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`

const BoxLegenda = styled(Box)`
  padding: ${pxToRem(10)} ${pxToRem(20)};
  border-top: 1px solid #d3dce2;
  box-shadow: none;
  border-radius: 0 0;
  dl {
    display: flex;
    color: #888;
    font-size: ${pxToRem(13)};
    dd {
      margin-left: ${pxToRem(10)};
      &::before {
        content: '- ';
      }
      flex: 1;
    }
  }
`

const ModalLayout = styled.div`
  display: flex;
  padding-left: ${pxToRem(20)};
  padding-right: ${pxToRem(20)};
  > div:first-child {
    padding-top: ${pxToRem(20)};
    padding-bottom: ${pxToRem(20)};
  }
  > div:last-child {
    flex: 1;
    padding: ${pxToRem(30)};
    padding-top: ${pxToRem(20)};
    padding-bottom: ${pxToRem(20)};
    border-left: 1px solid #d3dce2;
    margin-left: ${pxToRem(16)};
  }
  @media only screen and (max-width: 700px) {
    flex-direction: column;
    > div:last-child {
      border: none;
      padding-left: 0;
      margin-left: 0;
    }
  }
`

const DefinitionList = styled.dl`
  margin: 2em 0;
  &:first-child {
    margin-top: 0;
  }
  dd,
  dt {
    padding: 0;
    margin: 0;
    font-size: ${pxToRem(14)};
  }
  dd {
    span,
    strong {
      color: ${color.secondary};
    }
    strong {
      font-weight: bold;
    }
  }
  dt {
    text-transform: uppercase;
    font-weight: bold;
    margin-bottom: 1em;
  }
  & > dl {
    overflow: auto;
    margin-top: 0;
    max-height: 260px;
  }
  dl {
    &:first-child {
      margin-top: 0;
    }
    dt {
      color: ${color.primary};
      margin-bottom: 0;
      font-weight: bold;
    }
  }
`

const WrapperStatus = styled.div`
  width: 20px;
  height: 20px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  position: relative;

  img {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    margin: auto;
    width: 14px;
  }

  ${({ type }) => {
    return `
      ${type === 'warning' ? 'img { width: unset; height: 12px; }' : ''}
      background: ${color[type]}
    `
  }};
`

const WrapperStatusModal = styled(WrapperStatus)`
  display: inline-flex;
  margin-left: ${pxToRem(10)};
`

const WrapperStatusLegend = styled(WrapperStatus)`
  width: ${pxToRem(18)};
  height: ${pxToRem(18)};
  span {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  position: relative;

  img {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    margin: auto;

    ${({ type }) => {
    return type === 'warning' ? 'height: 11px;' : 'width: 10px;'
  }};
  }
`

const WrapperFilters = styled.div`
  margin-bottom: ${pxToRem(10)};
  @media only screen and (min-width: 383px) {
    margin-bottom: ${pxToRem(90)};
  }
`

const SelectFilter = styled.div`
  width: ${prop => (prop.width ? pxToRem(prop.width) : pxToRem(120))};
  margin-top: ${pxToRem(10)};
  height: ${pxToRem(40)};
  margin-left: auto;
  background: #fff;

  @media only screen and (min-width: 383px) {
    float: right;
    margin-right: ${prop => (!!prop.marginRight ? pxToRem(prop.marginRight) : '0px;')};
  }
`

const Selects = styled(Select)`
  font-size: ${pxToRem(14)};
`

class ConsumptionMap extends Component {
  constructor(props) {
    super(props)

    this.state = {
      openConsumptionMapModal: false,
      areaDefault: { value: null, label: null },
      yearDefault: { value: null, label: null },
      areaAdded: false,
      yearAdded: false
    }
  }

  componentDidMount() {
    const { fetchAreaList, fetchInitialState } = this.props

    fetchInitialState()
    fetchAreaList()
  }

  componentDidUpdate() {
    if (this.props.areas.length > 0 && !this.state.areaAdded) {
      let area = this.props.areas[0]
      this.changeArea(area)
      this.setState(state => ({
        areaAdded: true,
        areaDefault: area
      }))
    }

    if (this.props.yearList.length > 0 && !this.state.yearAdded) {
      let year = this.props.yearList[0]
      this.changeYear(year)

      this.setState(state => ({
        yearAdded: true,
        yearDefault: year
      }))
    }
  }

  closeModal = () => {
    this.setState(state => ({
      openConsumptionMapModal: false
    }))
  }

  changeArea = (area) => {
    const { label = '', value = 0 } = area
    this.props.changeArea(area)
    this.props.fetchYearList(value)
    this.props.fetchInitialState()

    if (value !== this.props.areaId && !!this.props.year && area.length > 0) {
      this.props.fetchConsumptionMap(this.props.year, value)
    }

    this.setState(state => ({
      areaDefault: area,
      yearDefault: undefined
    }))
  }

  changeYear = (year) => {
    const { label, value } = year
    this.props.changeYear(year)

    if (year === '') {
      this.props.fetchCleanYear()
    } else {
      this.props.fetchConsumptionMap(value, this.props.areaId)
    }

    this.setState(state => ({
      yearDefault: year
    }))
  }

  openModal = (e, id) => {
    e.preventDefault()
    this.props.fetchConsumptionMapItem(id)
    this.setState(state => ({
      openConsumptionMapModal: true
    }))
  }

  render() {
    const {
      menuItems = [],
      router,
      fetchConsumptionMap,
      consumptionMap,
      last_update,
      fetching,
      fetch_errors,
      item,
      yearList,
      year,
      areas,
      areaId
    } = this.props

    const { closeModal, openModal, changeArea, changeYear } = this
    const { openConsumptionMapModal, areaDefault, yearDefault } = this.state

    const CellComponent = ({ name, value }) => {
      let icon

      if (value.status === 'success') {
        icon = statusSuccess
      }

      if (value.status === 'danger') {
        icon = statusDanger
      }

      if (value.status === 'warning') {
        icon = statusWarning
      }

      return (
        <Fragment>
          <WrapperStatus type={value.status}>
            {value.status ? (
              <div>
                <span aria-hidden={true}>
                  <img src={icon} alt={value.status} />
                </span>
              </div>
            ) : (
              <span>-</span>
            )}
          </WrapperStatus>
          {!!value.status && (
            <SeeLink
              onClick={e => {
                openModal(e, value.id)
              }}
            >
              Ver
            </SeeLink>
          )}
        </Fragment>
      )
    }

    const columns = {
      id: {
        hide: true
      },
      responsible_name: {
        label: 'Orgão Responsável',
        sortable: true,
        width: 150
      },
      jan: {
        label: `JAN ${year}`,
        CellComponent: CellComponent,
        sortable: false,
        width: 25
      },
      fev: {
        label: `FEV ${year}`,
        CellComponent: CellComponent,
        sortable: false,
        width: 25
      },
      mar: {
        label: `MAR ${year}`,
        CellComponent: CellComponent,
        sortable: false,
        width: 25
      },
      abr: {
        label: `ABR ${year}`,
        CellComponent: CellComponent,
        sortable: false,
        width: 25
      },
      mai: {
        label: `MAI ${year}`,
        CellComponent: CellComponent,
        sortable: false,
        width: 25
      },
      jun: {
        label: `JUN ${year}`,
        CellComponent: CellComponent,
        sortable: false,
        width: 25
      },
      jul: {
        label: `JUL ${year}`,
        CellComponent: CellComponent,
        sortable: false,
        width: 25
      },
      ago: {
        label: `AGO ${year}`,
        CellComponent: CellComponent,
        sortable: false,
        width: 25
      },
      set: {
        label: `SET ${year}`,
        CellComponent: CellComponent,
        sortable: false,
        width: 25
      },
      out: {
        label: `OUT ${year}`,
        CellComponent: CellComponent,
        sortable: false,
        width: 25
      },
      nov: {
        label: `NOV ${year}`,
        CellComponent: CellComponent,
        sortable: false,
        width: 25
      },
      dez: {
        label: `DEZ ${year}`,
        CellComponent: CellComponent,
        sortable: false,
        width: 25
      }
    }

    let itemIcon
    let itemInfo

    if (item.status === 'success') {
      itemIcon = statusSuccess
      itemInfo = 'Verde'
    }

    if (item.status === 'danger') {
      itemIcon = statusDanger
      itemInfo = 'Vermelho'
    }

    if (item.status === 'warning') {
      itemIcon = statusWarning
      itemInfo = 'Amarelo'
    }

    return (
      <Fragment>
        <Grid>
          <Header router={router} />
          <Sidebar menuItems={menuItems} router={router} />
          <Content>
            <ContentHeader
              title="Produtos Controlados"
              subtitle="Mapas de Consumo"
              last_update={dateToBrFormat(new Date(last_update))}
            >
            </ContentHeader>
            <WrapperFilters>
              <SelectFilter>
                <Selects
                  value={yearDefault ? yearDefault : null}
                  onChange={value => {
                    changeYear(value)
                  }}
                  options={[...yearList]}
                />
              </SelectFilter>

              <SelectFilter width={240} marginRight={10} marginTop={10}>
                <Selects
                  value={areaDefault ? areaDefault : undefined}
                  onChange={value => {
                    changeArea(value)
                  }}
                  options={[...areas]}
                />
              </SelectFilter>
            </WrapperFilters>

            <DataTable
              loading={fetching.consumptionMap}
              error={fetch_errors.consumptionMap}
              fetchData={() => {
                fetchConsumptionMap({ year, areaId })
              }}
              columns={columns}
              height={600}
              width={1100}
              data={consumptionMap}
            />
            {!fetch_errors.consumptionMap &&
              !!(consumptionMap || []).length && (
                <BoxLegenda title="Legenda">
                  <dl>
                    <dt>
                      <WrapperStatusLegend type={'success'}>
                        <span aria-hidden={true}>
                          <img
                            src={statusSuccess}
                            alt={'Mapa de Consumo cadastrado na data correta.'}
                          />
                        </span>
                      </WrapperStatusLegend>
                    </dt>
                    <dd>Mapa de Consumo cadastrado na data correta.</dd>
                  </dl>
                  <dl>
                    <dt>
                      <WrapperStatusLegend type={'warning'}>
                        <span aria-hidden={true}>
                          <img
                            src={statusWarning}
                            alt={'Mapa de Consumo não cadastrado e dentro do prazo de protocolo.'}
                          />
                        </span>
                      </WrapperStatusLegend>
                    </dt>
                    <dd>Mapa de Consumo não cadastrado e dentro do prazo de protocolo.</dd>
                  </dl>
                  <dl>
                    <dt>
                      <WrapperStatusLegend type={'danger'}>
                        <span aria-hidden={true}>
                          <img
                            src={statusDanger}
                            alt={'Mapa de Consumo não cadastrado e fora do limite de protocolo.'}
                          />
                        </span>
                      </WrapperStatusLegend>
                    </dt>
                    <dd>Mapa de Consumo não cadastrado e fora do limite de protocolo.</dd>
                  </dl>
                </BoxLegenda>
              )}
            <ResponsiblesContent />
          </Content>
        </Grid>
        <Modal
          title={'Mapa de Consumo'}
          safeContent={false}
          loading={fetching.consumptionMapItem}
          open={openConsumptionMapModal}
          error={fetch_errors.consumptionMapItem}
          size={'large'}
          closeMethod={closeModal}
        >
          <ModalLayout>
            <div>
              <DefinitionList>
                <dt>Data de Emissão do Protocolo</dt>
                <dd>
                  {item['issue_date'] ? (
                    <Moment element={'span'} format={'DD/MM/YYYY'}>
                      {item['issue_date']}
                    </Moment>
                  ) : (
                    <span>---</span>
                  )}
                </dd>
              </DefinitionList>
              <DefinitionList>
                <dt>Orgão Responsável</dt>
                <dd>{item['name'] || '-'}</dd>
              </DefinitionList>
              <DefinitionList>
                <dt>Área</dt>
                <dd>{item['area_name'] || '-'}</dd>
              </DefinitionList>
              <DefinitionList>
                <dt>
                  Status
                  <WrapperStatusModal type={item['status']}>
                    <span>
                      <img src={itemIcon} alt={item['status']} />
                    </span>
                  </WrapperStatusModal>
                </dt>
                <dd>
                  <strong>{itemInfo}</strong>
                </dd>
              </DefinitionList>
              <WrapperSeeButton>
                {!!item['document_path'] && (
                  <Button link href={item['document_path']} target="_blank">
                    Ver Documento
                  </Button>
                )}
              </WrapperSeeButton>
            </div>
            <div>
              <DefinitionList>
                <dt>Observações</dt>
                {!!(item['notes'] || []).length ? (
                  <dl>
                    {sortBy(item['notes'] || [], item => -new Date(item.updated_at)).map(
                      (note, index) => {
                        return (
                          <dl key={index}>
                            <dt>
                              {note['updated_at'] ? (
                                <Moment element={'span'} format={'DD/MM/YYYY - HH:mm'} locale={'pt-br'}>
                                  {note['updated_at']}
                                </Moment>
                              ) : (
                                <span>---</span>
                              )}
                            </dt>
                            <dd>{note.content}</dd>
                          </dl>
                        )
                      }
                    )}
                  </dl>
                ) : (
                  <dl>
                    <dd>Nenhum registro encontrado</dd>
                  </dl>
                )}
              </DefinitionList>
            </div>
          </ModalLayout>
        </Modal>
      </Fragment>
    )
  }
}

const mapStateToProps = state => ({
  fetching: state.consumptionMap.fetching,
  fetch_errors: state.consumptionMap.fetch_errors,
  consumptionMap: state.consumptionMap.items,
  last_update: state.consumptionMap.last_update,
  item: state.consumptionMap.consumptionMapItem,
  year: state.consumptionMap.year,
  areaId: state.consumptionMap.areaId,
  areaName: state.consumptionMap.areaName,
  yearList: state.consumptionMap.yearList,
  areas: state.consumptionMap.areaList
})

const mapDispatchToProps = dispatch => {
  return {
    fetchInitialState: () => {
      dispatch(consumptionMapActions.fetchInitialState())
    },
    fetchConsumptionMapItem: id => {
      dispatch(consumptionMapActions.fetchConsumptionMapItem(id))
    },
    fetchConsumptionMap: (year, areaId) => {
      dispatch(consumptionMapActions.fetchConsumptionMap(year, areaId))
    },
    changeYear: year => {
      dispatch(consumptionMapActions.changeYear(year))
    },
    changeArea: area => {
      dispatch(consumptionMapActions.changeArea(area))
    },
    fetchYearList: (areaId) => {
      return dispatch(consumptionMapActions.fetchYearList(areaId))
    },
    fetchAreaList: () => {
      return dispatch(consumptionMapActions.fetchAreaList())
    },
    fetchCleanYear: () => {
      dispatch(consumptionMapActions.fetchCleanYear())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConsumptionMap)



// WEBPACK FOOTER //
// ./src/containers/ControlledProducts/ConsumptionMap.js